<template>
  <a-modal
    :title="title"
    :width="500"
    :visible="visible"
    centered
    :maskClosable="false"
    @ok="handleSubmit"
    @cancel="handleCancel()"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        @submit="handleSubmit"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
      >
        <a-form-model-item label="角色名称" prop="name">
          <a-input v-model="form.name" placeholder="请输入角色名称" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import { Setting } from "@/api";
export default {
  components: {},
  data() {
    return {
      title: "",
      type: "",
      confirmLoading: false,
      visible: false,
      formData: {
        name: "", //名称
      },
      form: {},
      rules: {
        name: [this.common.rulesReq("请输入角色名称")],
      },
    };
  },
  mounted() {},
  created() {
    this.form = JSON.parse(JSON.stringify(this.formData));
  },
  methods: {
    async open(type, data) {
      this.type = type;
      this.title = type == "edit" ? "编辑角色" : "添加角色";
      this.visible = true;
      if (type == "edit" && data) {
        this.form.id = data.id;
        this.form.name = data.name;
      }
    },

    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let newForm = JSON.parse(JSON.stringify(this.form));
          if (this.type == "edit") {
            delete newForm.updateTime;
            delete newForm.createTime;
          }
          this.addsave(newForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 提交
    addsave(data) {
      this.confirmLoading = true;
      console.log(data);
      Setting.saveRole(data).then(res => {
        if (res.code == this.config.pubCode) {
          this.pubMsg.tipMessage(
            this.type == "edit" ? "编辑成功！" : "添加成功！",
            "success"
          );
          this.handleCancel(1);
        }
        this.confirmLoading = false;
      });
    },
    handleCancel(data) {
      this.$emit("ok", data);
      this.visible = false;
      this.form = JSON.parse(JSON.stringify(this.formData));
      this.$refs.ruleForm.resetFields();
    },
  },
};
</script>
<style lang="less" scoped></style>
